import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  smoLeads: [],
  detailedView: {},
  smeList: [],
  allprojects: [],
  loading: false,
};

export const getSmoLeads = createAsyncThunk("smo/getsmoleads", async (data) => {
  const res = await apiRequest({
    method: "get",
    url: `crm-leads/smo-leads?page=${data.page}&limit=${data.limit}&date=${data.date}&search=${data.search}&project_id=${data.project_id}`,
  });

  return res;
});
export const getsmoDetailedView = createAsyncThunk(
  "smo/smodetailedview",
  async (id) => {
    const res = await apiRequest({
      method: "get",
      url: `crm-leads/assigned?leadId=${id}`,
    });
    console.log("Assign response", res);
    return res;
  }
);
export const getsmeList = createAsyncThunk("crm/getsmelist", async (data) => {
  const res = await apiRequest({
    method: "get",
    url: `crm-leads/get-sme-list?page=1&limit=no&search=${data.search}`,
  });
  return res;
});
export const assignSme = createAsyncThunk("smo/assignsme", async (data) => {
  const res = await apiRequest({
    method: "post",
    url: `crm-leads/assign?leadId=${data.course_enrollment_id}`,
    data: data,
  });
  return res;
});

export const getProjects = createAsyncThunk("crm/getProjects", async () => {
  const res = await apiRequest({
    method: "get",
    url: `crm-leads/get-project-list`,
  });
  return res;
});

const smoSlice = createSlice({
  name: "smo",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSmoLeads.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSmoLeads.fulfilled, (state, action) => {
      state.loading = false;
      state.smoLeads = action.payload;
    });
    // -----------------------------------smodeatiledview-----------------------------
    builder.addCase(getsmoDetailedView.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getsmoDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.detailedView = action.payload.data;
    });
    // ---------------------------------------------smelist--------------------------------
    builder.addCase(getsmeList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getsmeList.fulfilled, (state, action) => {
      state.loading = false;
      state.smeList = action.payload.data;
    });
    // -------------------------------------get projects  -----------------------------------
    builder.addCase(getProjects.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjects.fulfilled, (state, action) => {
      state.loading = false;
      state.allprojects = action.payload.data;
    });
    // ----------------------------------------assignsme-----------------------------------------
    builder.addCase(assignSme.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignSme.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(assignSme.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

// export const { apiCallData, admissionReg, storeId } = smoSlice.actions;

export default smoSlice.reducer;
